import { atom, computed, map } from 'nanostores'
import { $supplementsSettings } from '../logged-in-settings'
import type { Supplement as PopsSupplement } from '@/types/pops'
import { fetchSupplements } from '@/clients/pops/client'

export const $popsSupplements = atom<PopsSupplement[]>([])
export const $promises = map<Record<string, Promise<any> | undefined>>()

export const $sanitySupplements = computed(
  $supplementsSettings,
  (supplementsSettings) => {
    return supplementsSettings?.options || []
  },
)

export const $supplements = computed(
  [$popsSupplements, $sanitySupplements],
  (popsSupplements, sanitySupplements) => {
    return sanitySupplements.filter((sanitySupplement) => {
      if (sanitySupplement.type === 'detox_tea') return true

      return popsSupplements.some(
        (popsSupplement) => popsSupplement.name === sanitySupplement.popsValue,
      )
    })
  },
)

export const loadPopsSupplements = async () => {
  const promiseKey = 'loadSupplements'

  if ($promises.get()[promiseKey]) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const rawSupplements = await fetchSupplements()
    $popsSupplements.set(rawSupplements)
  })()

  $promises.setKey(promiseKey, promise)

  return promise
}

export const loggables = {
  'supplement/$popsSupplements': $popsSupplements,
  'supplement/$sanitySupplements': $sanitySupplements,
  'supplement/$supplements': $supplements,
  // 'supplement/$promises': $promises,
}
